// extracted by mini-css-extract-plugin
module.exports = {"textSlot":"DropdownMenu-module__textSlot___jXPnT","items":"DropdownMenu-module__items___GrX-V","divider":"DropdownMenu-module__divider___7VAta"};